export enum AuthProvider {
  'WindowsLiveId' = 0,
  'OrgId' = 2,
  'AAD' = 4,
}
